import React from "react";
import { Button, Group } from "@mantine/core";

const NumericKeyboard = ({ onKeyClick, clases = "w-100", iconReset = false, iconSearch = false, hideControls = false }) => {
  const handleClick = (key) => {
    onKeyClick(key);
  };

  // Matriz de botones para el teclado numérico
  const buttons = [
    [1, 2, 3],
    [4, 5, 6],
    [7, 8, 9],
    ["borrar", 0, "enter"],
  ];

  return (
    <Group position="center" mt={10} className={`d-flex flex-column ${clases}`}>
      {buttons.map((row, rowIndex) => (
        <Group key={rowIndex} mb={10}>
          {row.map((buttonKey, columnIndex) => (
            <Button
              size="x4"
              variant="default"
              key={columnIndex}
              onClick={() => handleClick(buttonKey)}
              h={95}
              w={120}
              style={{
                borderColor: buttonKey === "borrar" ? "red" : buttonKey === "enter" ? "teal" : "#6991cc",
                display: hideControls && (buttonKey === "borrar" || buttonKey === "enter") ? "none" : "block",
              }}
              className="button-keyboard-numeric-animation "
            >
              {buttonKey === 'borrar' ? (
                iconReset ?
                  <i className="fas fa-redo-alt fa-flip-horizontal" style={{ fontSize: '5rem',color:"red" }} />
                  :
                  <i className="fas fa-backspace" style={{ fontSize: '5rem',color:"red" }} />
              ) : buttonKey === 'enter' ? (
                iconSearch ?
                  <i className="fas fa-search" style={{ fontSize: '5rem' ,color:"green"}} />
                  :
                  <i className="fas fa-check" style={{ fontSize: '5rem' }} />
              ) : (
                <span style={{ fontSize: "5rem", paddingLeft: "0px", paddingRight: "0px" }}>{buttonKey}</span>
              )}
            </Button>
          ))}
        </Group>
      ))}
    </Group>
  );
};

export default NumericKeyboard;
